<template>
  <div class="no-results">
    <EMessageTips
      :tips-message="getTranslation('.tips')"
      :tips="tips"
    >
      {{ getTranslation('') }}
      “<strong
        class="no-results__query"
        data-test-id="no-results-query"
      >{{ query }}</strong>”
    </EMessageTips>
    <EButton
      v-if="back"
      as="a"
      size="m"
      variant="outline"
      :href="backUrl"
      class="no-results__back"
      data-test-id="no-results-back"
    >
      {{ $t('common.pagination.backfirst') }}
    </EButton>
  </div>
</template>

<script>
import EMessageTips from '~~/common/vue/components/message-tips';
import EButton from '~~/common/vue/components/button';

export const tipsCount = 3;

export default {
  name: 'ENoResults',
  components: {
    EButton,
    EMessageTips,
  },
  props: {
    /**
     * If there are no results because of an error
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * The search query
     */
    query: {
      type: String,
      required: true,
    },
    /**
     * Whether to display the "back" button with a link to the first page of results.
     */
    back: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translationPrefix() {
      return `common.search.${this.error ? 'error' : 'noresults'}`;
    },
    tips() {
      return Array.from({ length: tipsCount }, (value, index) => this.getTranslation(`.tip${index + 1}`));
    },
    backUrl() {
      const query = { ...this.$route.query, p: undefined };
      const { href } = this.$router.resolve({ query });
      return href;
    },
  },
  methods: {
    getTranslation(part) {
      return this.$t(`${this.translationPrefix}${part}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.no-results {
  background: var(--color-background-primary);
  flex-grow: 1;
  margin-top: $space-1s;
  padding: $space-m $space-m $space-2l;

  @include desktop {
    margin-top: 0;
    padding-top: $space-1s;
  }
}

.no-results__query {
  white-space: nowrap;
}

.no-results__back {
  margin-top: $space-s;
}
</style>
